<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-12">
                  <div class="form-group">
                    <label>Employee<span class="text-danger">*</span></label>
                    <input type="text" id="nama" name="nama" v-model="currentData.nama" disabled>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Date <span class="text-danger">*</span></label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker v-model="currentData.tanggal" class="picker" :editable="true" :clearable="false"
                      disabled />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Shift <span class="text-danger">*</span></label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <!-- <datepicker v-model="currentData.shift" class="picker" :editable="true" :clearable="false"
                        required />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a> -->
                      <model-select :options="needData2" :settings="{ settingOption: value, settingOption: value }"
                              v-model="currentData.shift_id" class="custom-width form-control" placeholder="" ></model-select>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Clock in<span class="text-danger">*</span></label>
                    <input type="time" id="jam_masuk" name="jam_masuk" v-model="currentData.jam_masuk">
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Clock out<span class="text-danger">*</span></label>
                    <input type="time" id="jam_keluar" name="jam_keluar" v-model="currentData.jam_keluar">
                  </div>
                </div>

                <!-- <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between ">
                      <label>Employee <span class="text-danger">*</span></label>
                    </div>
                    <multi-select :options="needData1" :selected-options="employees" style="z-index:504"
                      placeholder="select Employee" @select="onSelectEmployees">
                    </multi-select>
                  </div>
                </div> -->
                <div class="col-lg-12 d-flex">
                  <button type="submit" class="btn btn-submit me-2">Update</button>
                  <router-link to="schedule" class="btn btn-cancel">Cancel</router-link>
                  <button type="button" @click="showModal('deleteSchedule')" class="btn btn-danger ms-auto" data-bs-toggle="tooltip"
                    data-bs-placement="top" title="Delete schedule"><i class='bx bx-trash'></i></button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>

  <div class="modal fade" id="deleteSchedule" ref="deleteSchedule" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLongTitle">Delete Schedule</h5>
                  <button type="button" class="close" @click="hideModal2('deleteSchedule')" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <form @submit.prevent="deleteSchedule">
                  <div class="modal-body">
                      Are you sure want to delete this schedule?
                  </div>
                  <div class="modal-footer d-flex justify-content-end">
                      <button type="button" class="btn  btn-secondary"
                          @click="hideModal2('deleteSchedule')">cancel</button>
                      <button type="submit" class="btn  btn-danger">Delete</button>
                  </div>
              </form>
          </div>
      </div>
  </div>

</template>

<style scoped>
.form-group input[type="datetime-local"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="time"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="datetime-local"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}

.form-group input[type="time"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}
</style>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout , selectedBranch } from "@/assets/js/function";
import { ModelSelect, MultiSelect } from 'vue-search-select';


export default {
  components: {

    ModelSelect,
    MultiSelect

  },
  name: "editlocation",
  data() {
    return {
      filter: true,
      title: "Edit Schedule",
      title1: "edit schedule data",
      config: "",
      api: "",
      foto_ktp_img: "",
      googleMap: "",

      //data
      currentData: {
        shift_id: null,
      },

      ///multi select
      needData1: [],
      needData2: [],

      ///multi select
      // locations: [],
      employees: [],

      // lastSelectItemLocation: {},
      lastSelectItemEmployee: {},
    };
  },
  

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }

    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    this.namaCompany = localStorage.getItem('namaCompany');

    localStorage.setItem('actionState', 'update')

    this.currentData = JSON.parse(localStorage.getItem('currentData'));
    this.preparedData();

  },

  watch: {
    "currentData.shift_id"(newIdShift) {
      // Find the selected shift's jam_masuk from needData2
      const selectedShift = this.needData2.find(
        (item) => item.value === newIdShift
      );
      if (selectedShift) {
        // Update the clock-in time with the selected shift's jam_masuk
        // this.currentData.jam_masuk = selectedShift.text.match(/\(([^-]*)/)[1].trim(); // Extracts jam_masuk
        
        const shiftTimes = selectedShift.text.match(/\(([^-]*) - ([^)]*)\)/);
        if (shiftTimes) {
          this.currentData.jam_masuk = shiftTimes[1].trim(); // Set jam_masuk
          this.currentData.jam_keluar = shiftTimes[2].trim(); // Set jam_keluar
        }
      }
    },
  },

  methods: {

    showModal(modal_name) {
        this.$refs[modal_name].classList.add('show');
        this.$refs[modal_name].style.display = 'block';
    },

    hideModal2(modal_name) {
        this.$refs[modal_name].classList.remove('show');
        this.$refs[modal_name].style.display = 'none';
    },
    
    preparedData() {

      const needData1 = JSON.parse(localStorage.getItem('employeeList'));
      needData1.forEach((item, index) => {
        const item_prepare = { value: item.id, text: item.nama + ' (' + item.telepon + ')' };
        this.needData1.push(item_prepare);
      });

      const needData2 = JSON.parse(localStorage.getItem('shiftList'));
      needData2.forEach((item, index) => {
        const item_prepare = { value: item.id, text: item.nama_shift + ' (' + item.jam_masuk + ' - ' +  item.jam_pulang + ')'  };
        this.needData2.push(item_prepare);
      });

      const index = this.needData1.findIndex((record) => record.value == this.currentData.employee_id);
      const indexShift = this.needData2.findIndex((record) => record.value == this.currentData.shift_id);

      this.currentData.nama = this.needData1[index].text;
      this.currentData.shift_id = this.needData2[indexShift].value;
      this.currentData.tanggal = new Date(this.currentData.tanggal);
      this.employees = [];

    },
    onSelectEmployees(items, lastSelectItem) {
      this.employees = items
      this.lastSelectItemEmployee = lastSelectItem
    },

    formatDateLocaly(dateInput) {
      const dateObj = new Date(dateInput);
      if (isNaN(dateObj.getTime())) return null; // Invalid date check

      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    async insert() {
      
      let formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.delete("tanggal");
      formData.append("tanggal", this.formatDateLocaly(this.currentData.tanggal));

      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
      // return false;

      

      const api = base_url + '/v3/schedule/update';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
        AlertBottom(data.message);
        goPage("schedule");

      }else {
        AlertPopup2("error", "", data.message, true, 1500);
      }

     
    },

    async deleteSchedule() {
        let formData = new FormData();
        appendForm(formData)

        formData.append("id", this.currentData.id);

        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }
        // return false;

        const api = base_url + '/v3/schedule/delete';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        
        if(data.status){
            
                
                this.hideModal2('deleteSchedule');
                goPage("schedule");
                AlertBottom(data.message);

            
        }else {
            AlertPopup2("error", "", data.message, true, 1500);
        }

        

    },
    
    // terminate(id, nama) {
    //     this.id_terminate = id;
    //     this.nama_terminate = nama;
    //     this.tanggal_terminate = new Date();
    // }

  },

};
</script>
